import ClientContactDetail from "@/services/client-contact-details";

export default {
    methods: {
        async getContactDetails(actorId) {
            try {
                const {
                    response
                } = await ClientContactDetail.getContactDetails(actorId);
                if (response.code === 200) {
                    return response.resources;
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                console.error(error);
                this._message("Error fetching contact details", "error");
            }
        },
        checkContactTypeHasNextPrimary(types, contacts) {
            if (!Array.isArray(types)) {
                types = [types];
            }

            return types.some(type =>
                contacts.some(
                    contact => contact.type == type && !contact.is_primary
                )
            );
        }
    }
};
